module.exports = __webpack_public_path__ + "img/filter-funnel-02.5d50d102.svg";